import React from 'react'
import { CartItems } from '../Components/CartItems/CartItems'

export const Cartlogo = () => {
  return (
    <div>
      <CartItems/>
    </div>
  )
}
